import styled from 'styled-components';

import { createVar, sizeUp, vars } from '~/theme';
import { DesignSidePanelSt } from '~organisms/DesignSidePanel';

const _sidePanelWidth = createVar('_sidePanelWidth');

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  ...vars({
    [_sidePanelWidth]: sizeUp('50%', ['md', 'min(55%, 1100rem)']),
  }),

  [`${DesignSidePanelSt.Container}`]: {
    width: _sidePanelWidth,

    position: 'absolute',
    insetBlock: '0 -16rem',
    insetInline: `calc(100% - ${_sidePanelWidth}) 0`,
    zIndex: theme.overlayPosition.layer10,
  },
}));

export const DrawingAreaContainer = styled.div({
  inlineSize: `calc(100% - ${_sidePanelWidth} - 10rem)`,
  flex: 1,
  marginRight: `calc(${_sidePanelWidth} + 10rem)`,
  height: '100%',
});
